import labels from './labels.fi.json' with { type: 'json' };

// Shared by the web display and the API case title/body resolver.
export const CATALOGUE_LABELS_FI: Readonly<typeof labels> = labels;
